// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"587cec44","635":"0f69f067","787":"c4e7f8f9","856":"e86119fe"}[chunkId] + ".chunk.js";
};